export function isObject(value) {
  return value !== null && typeof value === 'object';
}
export function isI18NObject(value) {
  return isObject(value) && value.type === 'i18n';
}